import Base from "./Base"
import Preview from "./Preview"

const config = {
  ...Preview,
  clientKiosk: true,
  clientLinkBaseUri: "https://preview-app.operandio.com",

  auth: Preview.auth ? { ...Preview.auth } : { ...Base.auth }
}

config.auth.idleTimeoutMs = 1000 * 60 // 60 seconds

export default config
